import { InvoiceLine } from '@apply/api/src/api/PaymentApi';
import { useAuthentication } from '../../../../../../Login/hooks/useAuthentication';
import { ValuationAndUnderwritingRow } from './components/ValuationAndUnderwritingRow';
import { ValuationRow } from './components/ValuationRow';
import { UnderwritingRow } from './components/UnderwritingRow';
import { useBorrowerLoanType } from '../../../../../../queries/BorrowerFields/CoreFields';
import { LoanType } from '@apply/constants';

interface TableRowParameters {
    index: number;
    invoiceLine: InvoiceLine;
    totalUnderWritings: number;
}

export const TableRow: React.FC<TableRowParameters> = ({ index, invoiceLine, totalUnderWritings }) => {
    const { authentication } = useAuthentication();

    const [loanType] = useBorrowerLoanType();

    if (!authentication?.user) return;

    const { requireUnderwritingFee, requireValuationFee } = authentication.user;

    const isUnderWritingFeeRequired =
        requireUnderwritingFee || (loanType !== LoanType.Construction && loanType !== LoanType.FixFlip);

    const isValuationFeeRequired = requireValuationFee || (loanType !== LoanType.Construction && loanType !== LoanType.FixFlip);

    if (totalUnderWritings != 0 && isUnderWritingFeeRequired && isValuationFeeRequired) {
        return (
            <ValuationAndUnderwritingRow
                index={index}
                invoiceLine={invoiceLine}
            />
        );
    }

    if (totalUnderWritings === 0 || !isUnderWritingFeeRequired) {
        return (
            <ValuationRow
                index={index}
                invoiceLine={invoiceLine}
            />
        );
    }

    if (!isValuationFeeRequired) {
        return (
            <UnderwritingRow
                index={index}
                invoiceLine={invoiceLine}
            />
        );
    }

    throw new Error('Invalid fee combination');
};
